import { render, staticRenderFns } from "./PhotoMedia.vue?vue&type=template&id=05b6c96e&scoped=true&"
import script from "./PhotoMedia.vue?vue&type=script&lang=js&"
export * from "./PhotoMedia.vue?vue&type=script&lang=js&"
import style0 from "./PhotoMedia.vue?vue&type=style&index=0&id=05b6c96e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b6c96e",
  null
  
)

export default component.exports